import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-campus',
  imports: [SharedModule],
  templateUrl: './create-campus.component.html',
  styleUrl: './create-campus.component.scss'
})
export class CreateCampusComponent {

  @Output() close = new EventEmitter<void>();
  @Input() orgId: string = ''; // Organization ID passed from the parent component
  isLoading: boolean = false; // Loading state for the form submission
  @Input() campusDataToEdit: any = null; // To hold the campus data to be edited
  @Input() type = 'Create'; // Type of operation (create or edit)
  @Output() reload = new EventEmitter<void>(); // Event emitter to notify parent component for reloading data

  handleCloseDialog() {
    this.close.emit();
  }

  campusForm: FormGroup;
  submitted = false;

  statusOptions = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' }
  ];

  ngOnInit() {
    if (this.type === 'Update' && this.campusDataToEdit) {
      console.log(this.campusDataToEdit);
      this.campusForm.patchValue(this.campusDataToEdit); // Populate the form with existing data
    }
  }

  constructor(private fb: FormBuilder,
    private orgService: OrganizationService,
    private messageService: MessageService
  ) {
    this.campusForm = this.fb.group({
      organization_id: [2], // Hidden or disabled field if needed
      name: ['', Validators.required],
      address: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: [''  , Validators.required],
      postal_code: [''],
      contact_number: [''],
      email: ['', [Validators.email, Validators.required]],
      website: [null],
      campus_type: [''],
      status: ['', Validators.required],
      code: ['', Validators.required]
    });
  }

  submitForm() {
    this.submitted = true;

    if (this.campusForm.invalid) {
      this.campusForm.markAllAsTouched();
      return;
    }

    const payload: any = this.campusForm.value;
    payload.organization_id = this.orgId; // Set the organization ID from the input

    this.isLoading = true; // Set loading state to true

    if (this.type === 'Update') {
      payload.campus_id = this.campusDataToEdit.campus_id; // Add campus ID for update
      this.orgService.updateCampus(payload).subscribe(
        (response) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Campus updated successfully!' });
          this.reload.emit(); // Emit event to reload data in parent component
          this.handleCloseDialog(); // Close the dialog after successful submission
        },
        (error) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({
            severity: 'error', summary: 'Error', detail:
              error || 'Failed to update campus!'
          });
        }
      );
    } else {
      this.orgService.createCampus(payload).subscribe(
        (response) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Campus created successfully!' });
          this.reload.emit(); // Emit event to reload data in the parent component
          this.handleCloseDialog(); // Close the dialog after successful submission
          
        },
        (error) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({
            severity: 'error', summary: 'Error', detail:
              error || 'Failed to create campus!'
          });
        }
      );
    }

  }

}
